import dayjs from 'dayjs';

export interface CareArticle {
  id: string;
  mpn: string;
  purchasedTitle: string;
  status: Status;
  applicationDate?: dayjs.Dayjs;
  type: Type;
  months?: number;
  purchasedDate?: dayjs.Dayjs;
}

export enum Status {
  OPEN = 'OPEN',
  APPLIED = 'APPLIED',
}

export enum Type {
  CARE_ARTICLE = 'CARE_ARTICLE',
  WARRANTY = 'WARRANTY',
}
